<template>
    <div class="setting-box">
        <div class="setting-title">选项设置</div>
        <div class="setting-content">
            <div class="setting-content-item">
                <div>回答形式</div>
                <div class="type-box">
                    <div class="type-box1" @click="choseType('1')" :style="dataList.answerType == '1' ? choseStyle : {}">手动输入</div>
                    <div class="type-box1" @click="choseType('2')" :style="dataList.answerType == '2' ? choseStyle : {}">语音</div>
                </div>
            </div>
            <div class="setting-content-item">
                <div>输入类型</div>
                <el-radio-group :disabled="noEdit" v-model="dataList.inputBoxType" size="small">
                    <el-radio label="1">单行文本</el-radio>
                    <el-radio label="2">多行文本</el-radio>
                </el-radio-group>
            </div>
            <div class="setting-content-item">
                <div>字符限制</div>
                <div class="type-box">
                    <div class="limit-box1">
                        <el-input-number :disabled="noEdit" v-model="dataList.leastNumber" :controls="false" :step="1" size="large" step-strictly />
                    </div>
                    <span style="margin: 0 10px; line-height: 35px">-</span>
                    <div class="limit-box1">
                        <el-input-number :disabled="noEdit" v-model="dataList.MaxNumber" :controls="false" :step="1" step-strictly />
                    </div>
                </div>
            </div>
            <div class="setting-content-item">
                <div>占位文字</div>
                <div class="type-box">
                    <el-input :disabled="noEdit" v-model="dataList.placeHolderText" placeholder="请输入回答内容" />
                </div>
            </div>
            <div class="setting-content-item">
                <div>
                    填写内容限制
                    <el-tooltip class="box-item" effect="customized" content="选择文本输入框可输入的内容类型" placement="top">
                        <svg-icon name="tips" class="icon" />
                    </el-tooltip>
                </div>
                <div class="type-box">
                    <el-select
                        v-model="dataList.contentLimit"
                        :disabled="noEdit"
                        class="m-2"
                        style="width: 100%; height: 35px"
                        placeholder="Select"
                        size="large"
                    >
                        <el-option v-for="item in limitList" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup name="kr-fill-blank-setting">
const props = defineProps({
    dataList: {
        type: Object,
        default: () => ({}),
    },
    // 文本框是否可编辑
    noEdit: {
        type: Boolean,
        default: false,
    },
});
const choseStyle = {
    color: "rgba(34, 64, 195, 1)",
    background: "rgba(127, 148, 242, 0.1)",
    border: "1px solid rgba(127, 148, 242, 1)",
};
const limitList = [
    { label: "不限制", value: "" },
    { label: "文字", value: "T" },
    { label: "数字", value: "N" },
    { label: "字母", value: "E" },
    { label: "日期", value: "D" },
    { label: "姓名", value: "N" },
    { label: "手机号码", value: "P" },
    { label: "邮箱", value: "M" },
];

// 选择输入类型
function choseType(type) {
    props.dataList.answerType = type;
}
</script>
<style lang="scss" scoped>
@import "@/css/setting.scss";
:deep(.el-radio) {
    margin-right: 60px;
}
:deep(.el-input-number) {
    width: 98px;
}
.type-box {
    display: flex;
    margin-top: 8px;
    .type-box1 {
        width: 98px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        opacity: 1;
        border-radius: 4px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(229, 232, 238, 1);
        cursor: pointer;
        &:first-child {
            margin-right: 30px;
        }
    }
}

:deep(.el-select--large) {
    width: 100%;
    position: relative;
}
:deep(.el-select-dropdown__item) {
    line-height: 44px;
}
:deep(.el-input__inner) {
    height: 33px;
}
</style>
